import React from 'react';
import Skeleton from 'react-loading-skeleton';

export const LargeListViewSkeleton = () => (
	<React.Fragment>
		<div className="flex flex-col justify-between p-2 w-1/4">
			<Skeleton height={200} className="mb-4" />
			<Skeleton count={3} />
			<Skeleton height={46} />
		</div>

		<div className="flex flex-col justify-between p-2 w-1/2">
			<Skeleton height={40} width={100} />
			<Skeleton count={5} />
			<Skeleton count={5} />
		</div>

		<div className="flex flex-col justify-between p-2 w-1/4">
			<Skeleton count={2} />
			<Skeleton count={3} />
			<Skeleton height={46} count={2} />
		</div>
	</React.Fragment>
);

export default LargeListViewSkeleton;
